import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const r = await api.post(
          "/auth/session",
          { session_id },
          { withCredentials: true }
        );
        setUser(r.data);
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true, state: { user: r.data } });
      } catch (e) {
        const msg =
          e?.response?.data?.detail ||
          "Sign-in failed. Please try again.";
        setError(msg);
      }
    })();
  }, [navigate, setUser]);

  if (error) {
    return (
      <div
        data-testid="auth-error"
        className="min-h-screen flex items-center justify-center px-6"
      >
        <div className="max-w-md w-full panel p-6">
          <div className="label-cap mb-2">Sign-In Blocked</div>
          <p className="text-sm text-[#FFD9D6] leading-relaxed mb-4">{error}</p>
          <button
            data-testid="back-to-login-btn"
            onClick={() => {
              window.location.href = "/login";
            }}
            className="btn-outline w-full"
          >
            Back to login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-[#A1A1AA] font-mono text-sm">
      Signing you in…
    </div>
  );
}
